import { Home } from './UI/Layouts/Home'

function App() {
    return (
        <>
            <Home />
        </>
    )
}

export default App